import {
    createBrowserRouter,
} from "react-router-dom";
import Root from "./Root";
import Dashboard from "./Pages/Dashboard/Dashboard";
// import NewStudents from "./Pages/Students/Users";
import Categories from "./Pages/Categories/Categories";
import AddCategory from "./Pages/Categories/AddCategory";
import SubCategories from "./Pages/Categories/SubCategories";
import AddSubCategory from "./Pages/Categories/AddSubCategory";
import Instructors from "./Pages/Instructors/Instructors";
import AddInstructor from "./Pages/Instructors/AddInstructor";
import Courses from "./Pages/Courses/Courses";
import AddCourse from "./Pages/Courses/AddCourse";
import Sections from "./Pages/Courses/Sections";
import Users from "./Pages/Users/Users";
import Enrollments from "./Pages/Enrollments/Enrollments";
import Withdrawals from "./Pages/Withdrawals.js/Withdrawals";
import Finance from "./Pages/Finance/Finance";

const router = createBrowserRouter([
    {
        path: "/",
        element: <Root />,
        children: [
            {
                path: '/dashboard',
                element: <Dashboard />
            },
            {
                path: '/users',
                element: <Users />
            },
            {
                path: '/sellers',
                element: <Users sellers />
            },
            {
                path: '/courses',
                element: <Courses />
            },
            {
                path: '/categories',
                element: <Categories />
            },
            {
                path: '/add-category',
                element: <AddCategory />
            },
            {
                path: '/:categoryId/sub-categories',
                element: <SubCategories />
            },
            {
                path: '/add-sub-category/:categoryId',
                element: <AddSubCategory />
            },
            {
                path: '/add-instructor',
                element: <AddInstructor />
            },
            {
                path: '/add-course',
                element: <AddCourse />
            },
            {
                path: '/course-sections/:id',
                element: <Sections />
            },
            {
                path: '/enrollments',
                element: <Enrollments />
            },
            {
                path: '/withdrawals',
                element: <Withdrawals />
            },
            {
                path: '/finance',
                element: <Finance />
            },
        ]
    }
])

export default router